import { useEffect } from 'react'
import { useLocation } from 'react-router'
import './MessagesList.scss'
import Message from './components/Message'
import hocMessagesList from './hocMessagesList'

/**
 * Component shows all messages
 * coming from server interaction
 */
function MessagesList({ messagesList, removeMessage, removeAllMessages }) {
    const location = useLocation()
    useEffect(() => {
        removeAllMessages()
    }, [location])
    return (
        <div className="messages-list">
            {messagesList.map((message) => (
                <Message key={`${message.code}_${message.type}`} message={message} removeMessage={removeMessage} />
            ))}
        </div>
    )
}

export default hocMessagesList(MessagesList)
